import React, { FC, memo } from "../../../../lib/teact/teact";
import Avatar from "../../../common/Avatar";
import LotCheckBox from "../../ui/lotCheckBox";

type OwnProps = {
    convItemData: any,
    onClick: (id: number) => void;
    inSelectMode: boolean;
    selected: boolean;
    onChangeSelected: (id:number) =>void;
}

const ConversationItem: FC<OwnProps> = ({
    convItemData,
    onClick,
    inSelectMode,
    selected,
    onChangeSelected,
}) => {
    function getDisplayName(conv: any): string {
        if (conv.name != "")
            return conv.name;
        if (conv.recipients) {

            const contact = conv.recipients[0].contact
            if (contact && contact.name != "")
                return contact.name;
            else
                return conv.recipients[0].address
        }
        return "-"
    }
    const name = getDisplayName(convItemData)
    return (
        <div className=" common-container-row" onClick={() => {
            if (onClick){
                if (!inSelectMode)
                    onClick(convItemData.id)
                else {
                    onChangeSelected(convItemData.id)
                }
            }
        }}>
            <div className=" common-container-row left-panel">
                <Avatar text={name} size="small" ></Avatar>
                <div>{name}</div>
            </div>
            <div>
                {inSelectMode && <LotCheckBox checked={selected} />}
            </div>
        </div>
    )
}
export default memo(ConversationItem)